import React from 'react';
import { useTranslation } from 'react-i18next';
import { BlissNetLoadingScreen } from '@/components/BlissNetLoadingScreen';

export interface AppBootSplashProps {
  title?: string;
  message?: string;
}

/**
 * Global boot splash — same design as Profile's BlissNetLoadingScreen.
 * Pixel-matched twin of index.html #initial-loader.
 * Document direction stays with DocumentDirectionSync; this component does not set lang or dir.
 */
export const AppBootSplash: React.FC<AppBootSplashProps> = ({
  title,
  message,
}) => {
  const { t } = useTranslation();

  return (
    <BlissNetLoadingScreen
      title={title ?? t('bootSplash.loadingTitle')}
      message={message ?? t('bootSplash.preparingMessage')}
      loadingLabel={t('bootSplash.loadingLabel')}
      className="!z-[99999]"
    />
  );
};

export default AppBootSplash;
